require('./mixins/pexels_mock.js');
require('./mixins/icons_mock.js');

Pegasus.EditProxyObject = Em.Object.extend({});

(function(){
  var lastCreated;

  Pegasus.EditProxyObject.reopenClass({
    create: function(observer, params){
      if ( lastCreated ) {
        lastCreated.destroy();
      }

      var result = this._super.apply(this, arguments);
      Object.keys(params).forEach(function(param){
        Em.addObserver( result, param, observer, 'propertyChanged' );
      });
      lastCreated = result;
      return lastCreated;
    }
  });
})();

Pegasus.HistoryNavigator = Em.Mixin.create({
  actions: {
    receiveHistory: function(params){
      Em.get(Pegasus.CommandManager, 'instance').setProperties( params.payload );
    },

    requestRoll: function(position){
      this.send('navigatingCommands');

      this.say(window.vrChildWindow, {
        method: 'requestRoll',
        payload: {
          position: position
        }
      });
    }
  }
});

(function(){
  var callbacks = [];

  Pegasus.IOEventsMixin = Em.Mixin.create({
    actions: {
      requestTemplateOutput: function(forSending, callback){
        callbacks.push(callback);
        this.say( window.vrChildWindow, {
          method: 'requestTemplateOutput',
          payload: {
            forSending: forSending
          }
        });
      },
      receiveTemplateOutput: function(params){
        var toCall = callbacks.toArray();
        callbacks = [];
        toCall.forEach(function(callback){
          callback(params.payload.output);
        });
      }
    }
  });
})();

Pegasus.FrameReceivedEventsMixin = Em.Mixin.create({
  propertyChanged: function(sender, key, value, rev){
    var payload = {};
    payload[key] = value || sender.get(key);
    payload.touched = true;

    this.say( window.vrChildWindow, {
      method: 'receiveEdit',
      payload: payload
    });
  },

  didActivateFrameOfFrames: function(frame, frames){
    var self = this;
    frames.each(function(i, frame){
      if ( frame.contentWindow ) {
        self.say(frame.contentWindow, {
          method: 'requestBecomeInactiveDocument',
          payload: {}
        })
      }
    });

    window.vrChildWindow = frame.contentWindow;
    this.say(window.vrChildWindow, {
      method: 'requestBecomeActiveDocument',
      payload: {}
    });
  },

  clearTemplateRows: function(){
    this.say(window.vrChildWindow, {
      method: 'receiveClearTemplateRows',
      payload: {}
    });
  },

  notifyImageEditorOpened: function(){
    if ( window.parent === window ) { return; }

    this.say(window.parent, {
      method: 'receiveDidOpenImageEditor',
      payload: {}
    });
  },

  showHidden: function(){
    this.say(window.vrChildWindow, {
      method: 'receiveShowHidden',
      payload: {}
    });
  },

  hideHidden: function(){
    this.say(window.vrChildWindow, {
      method: 'receiveHideHidden',
      payload: {}
    });
  },

  actions: {
    didCancelMergeFields: function(params){
      this.send('saveAborted');
    },

    requestIntrinsicWidthBreach: function(params){
      var content = Pegasus.EditProxyObject.create(this, params.payload);
      this.send('suggestTemplateResize', content);
    },

    requestReplaceImage: function(params){
      var toolbar = Pegasus.lookupController('toolbar');
      var handler = params.payload;
      var actOn = handler.actOnProperty;

      handler.imageCompletionCallback = function(data){
        toolbar.set( actOn, data.encoded);
      };

      toolbar.set('imageHandler', handler);
      toolbar.replaceImage();
    },

    receiveImageFailure: function(params){
      this.get('controllers.autoSave').set('isError', true);
      this.set('controllers.template.isSaving', false);
      $('.saving-mask').remove();
    },
    receiveHiddenState: function(params) {
      Pegasus.lookupController('toolbar').set('hasHidden', params.payload.hasHidden);
    },

    requestTemplateImages: function(){
      this.say(window.vrChildWindow, {
        method: 'requestTemplateImages',
        payload: {}
      });
    },
    receiveTemplateImages: function(params){
      this.send('didLoadTemplateImages', params.payload);
    },
    requestBecomeInactiveDocument: Em.K,
    requestBecomeActiveDocument: Em.K,

    receiveActiveWindow: function(params){
      window.vrChildWindow = params.requestSource;
    },
    requestReplaceColors: function(map){
      this.say(window.vrChildWindow, {
        method: 'requestReplaceColors',
        payload: map
      });
    },

    receiveContextLoaded: function(){
      this.send('documentLoaded');
    },

    registerEmberFrame: Em.K,
    requestEditorContext: function(params){
      var passed, toolbarController, base;
      if ( params.requestSource === window ) {
        passed = {
          afterLoad: "",
          assetHost:"http://localhost:5000",
          isAuthorizedToRemoveLogo:false,
          includesFooter: false,
          isWhiteLabeled:false,
          isHelpEnabled: true,
          blacklistBlocks: [],
          isFeedbackEnabled: false,
          isSendTestEnabled: false,
          isTestKitEnabled: false,
          isUserGalleryEnabled: false,
          userLevelLogoHidden:false,
          forwardInstruction:"Next",
          showHints:true,
          takenListNames: [],
          selectableContactLists: [],
          documents: [{
            id: '',
            documentURL: "/pegasus_document/assets/pegasus_document-email-en.html",
            type: 'email',
            fields: {},
            template: window.vr_template(),
            uniqueID: 'demo'
          }]
        }
      } else {
        toolbarController = this.get('controllers.toolbar');
        base = this.get('controllers.template.activeDocument');
        passed = $.extend({}, base, {
          blacklistBlocks: toolbarController.get('blacklistBlocks'),
          includesFooter: toolbarController.get('includesFooter'),
          isAuthorizedToRemoveLogo: toolbarController.get('isAuthorizedToRemoveLogo'),
          userLevelLogoHidden: toolbarController.get('userLevelLogoHidden'),
          isWhiteLabeled: toolbarController.get('isWhiteLabeled'),
          isVrFooterLogoEnabled: toolbarController.get('isVrFooterLogoEnabled'),
          takenListNames: toolbarController.get('takenListNames'),
          selectableContactLists: toolbarController.get('selectableContactLists')
        });
      }

      this.say(params.requestSource, {
        method: 'receiveEditorContext',
        payload: passed
      });
    },

    requestWidgetCode: function(params){
      this.send('showWidgetCodeModal');
    },

    requestImageTransformation: function(params) {
      var self = this;

      $.ajax({
        url:'/image_transformations/encode_64',
        type:'POST',
        dataType: 'json',
        contentType: "application/json",
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify({
          custom_url: params.payload.url,
          style: "original"
        })
      }).done(function(data, state, response){
        self.say(params.requestSource, {
          method: 'receiveImageTransformation',
          payload: {
            isSuccess: true,
            data: data
          }
        });
      }).fail(function(response, resultType, errorMessage){
        self.say(params.requestSource, {
          method: 'receiveImageTransformation',
          payload: {
            isSuccess: false,
            data: response
          }
        });
      });
    },

    receiveAddRow: function(rowParams){
      this.say(window.vrChildWindow, {
        method: 'receiveAddRow',
        payload: rowParams
      });
    },

    requestEditPalette: function(){
      this.say(window.vrChildWindow, {
        method: 'requestEditPalette',
        payload: {}
      });
    },

    enteredIdleState: function(){
      this.say(window.vrChildWindow, {
        method: 'enteredIdleState',
        payload: {}
      });
    },

    requestRowAddition: function(){
      this.say(window.vrChildWindow, {
        method: 'requestRowAddition',
        payload: {}
      });
    },

    editBlock: function(params){
      // if an emptyview is requested and we are currently viewing blocks
      // do nothing
      var currentPanelMode = Pegasus.lookupController('toolbar').get('panelMode');
      if ( params.payload.payload.type === 'emptyView' && (currentPanelMode === 'Blocks') ) {
        return;
      }

      Pegasus.lookupController('toolbar').setProperties({
        content: Pegasus.EditProxyObject.create(this, params.payload),
        panelMode: 'Edit'
      });
    },

    editPalette: function(params){
      Pegasus.lookupController('toolbar').setProperties({
        content: Pegasus.EditProxyObject.create(this, params.payload),
        panelMode: params.payload.payload.type
      });
    },

    addRow: function(params){
      Pegasus.lookupController('toolbar').setProperties({
        content: Pegasus.EditProxyObject.create(this, params.payload),
        panelMode: 'Blocks'
      });
    },

    requestPaletteData: function(){
      this.say(window.vrChildWindow, {
        method: 'requestPaletteData',
        payload: {}
      });
    },

    receivePaletteData: function(params){
      var controller = Pegasus.lookupController('toolbar');
      if ( controller.get('payload.type') !== params.payload.payload.type ) {
        Pegasus.lookupController('toolbar').set('content', Pegasus.EditProxyObject.create(this, params.payload));
        return;
      }
      delete params.payload.payload // dont trigger a toolbar event
      controller.get('content').setProperties( params.payload ); // just update the values
    },

    requestExternalImageTransformation: function(url){
      this.say(window.parent, {
        method: 'requestImageTransformation',
        payload: {
          url: url
        }
      });
    },

    receiveImageTransformation: function(params) {
      $(window).trigger('didReceiveImageTransformation', params.payload);
    },

    receiveIconImages: function(params) {
      Em.run( this.get('controllers.iconsImages'), 'didCompleteRequest', params.payload.data );
    },

    receivePexelsImages: function(params) {
      Em.run( this.get('controllers.pexelsImages'), 'didCompleteRequest', params.payload.data );
    },

    receiveSavedImages: function(params) {
      Em.run( this.get('controllers.savedImages'), 'didCompleteRequest', params.payload.data );
    },

    requestPexelsImages: function(params) {
      this.say(params.requestSource, {
        method: 'receivePexelsImages',
        payload: {
          data: this.get('pexelsImagesData') || {}
        }
      });
    },

    requestSavedImages: function(params) {
      this.say(params.requestSource, {
        method: 'receiveSavedImages',
        payload: {
          data: this.get('savedImagesData') || {}
        }
      });
    },

    requestIconImages: function(params) {
      this.say(params.requestSource, {
        method: 'receiveIconImages',
        payload: {
          data: this.get('iconImagesData') || {}
        }
      });
    },

    didLoadEditor: Em.K,
    receiveEditorContext: function(params){
      this.set('templateContext', params.payload);
      var uri = $('<a>').attr('href', window.location.href.strip('/'))[0];

      this.set('controllers.template.isSaving', false);

      this.set('controllers.template.documents', params.payload.documents);

      Em.run(this, function(){
        this.set('controllers.toolbar.includesFooter', params.payload.includesFooter);
        this.set('controllers.toolbar.selectableContactLists', params.payload.selectableContactLists);
        this.set('controllers.toolbar.takenListNames', params.payload.takenListNames);
        this.set('controllers.toolbar.showHints', params.payload.showHints);
        this.set('controllers.toolbar.userLevelLogoHidden', params.payload.userLevelLogoHidden);
        this.set('controllers.toolbar.isAuthorizedToRemoveLogo', params.payload.isAuthorizedToRemoveLogo);
        this.set('controllers.toolbar.isWhiteLabeled', params.payload.isWhiteLabeled);
        this.set('controllers.toolbar.isVrFooterLogoEnabled', params.payload.isVrFooterLogoEnabled);
        this.set('controllers.toolbar.blacklistBlocks', params.payload.blacklistBlocks);
        this.set('controllers.toolbar.isUserPro', params.payload.isUserPro);



        Pegasus.set('options', params.payload);
        Pegasus.set('formSubmissionHost', params.payload.assetHost);
        Pegasus.set('templateAssetHost', params.payload.assetHost);
        Pegasus.stateMachine.initialize();
      });
    },

  },
  saveAndExit: Em.K,
  reset: function(){
    Pegasus.reset();
  },
  saveAndExit: function(){/*TODO*/},
  saveAndContinue: function(){
    //this.authWindow = window.open("https://8braham:iceman707@stg6.verticalresponse.com/users/sign_in", "_blank", "toolbar=no, scrollbars=no, resizable=yes, top=500, left=500, width=600, height=500");
    //this.authWindow = window.open(Pegasus.handoffHost(), "_blank", "toolbar=no, scrollbars=no, resizable=yes, top=500, left=500, width=630, height=590");
    Pegasus.lookupController('modal').set('presenter', Pegasus.OceansHandoffModal.create({
      contextMessaging: this.get('handoffMessage') || '',
      controller: this,
      cancelCallback: function(){
        Em.run( this, 'set', 'controllers.template.isSaving', false);
      }.bind(this)
    }));
  },
  requestHandoff: function(params){
    var handoffEmail = this.get('handoffPayload');

    this.say(params.requestSource, {
      method: 'receiveHandoff',
      payload: {
        template: $.extend( {
          name: 'Untitled Draft Email',
          subject: 'Untitled Email',
          handoff: true /* let responder know this is an email created from a remote context */
        }, handoffEmail )
      }
    });
  },
  handoffUrlGenerated: function(params){
    window.location.replace( params.payload.forward_url );
  },

  touchUserImage: Em.K,

  deleteUserImage: Em.K,

  touchSavedImage: function(id){
    this.say(window.parent, {
      method: 'touchUserImage',
      payload: {
        imageID: id
      }
    });
  },

  getEditorHelpVideo: function(){
    Pegasus.lookupController('modal').set('presenter', Pegasus.HelpVideoModal.create({
      controller: this
    }));
  },

  handoffMessage: null,

  requestSaveSnapshot: function(params){
    if ( window.parent !== window ) {
      var snap = $.extend( {
        handoff: false /* let responder know this is an email created from a remote context */
      }, params);

      this.set('lastSnap', snap);

      this.say(window.parent, {
        method: 'receiveSnapshot',
        payload: {
          template: snap
        }
      });
      return;
    }

    this.set('handoffMessage', Em.I18n.t('instructions.signup_to_save_your_work'));
    Pegasus.lookupRouter().send('saveAndContinue');
    Em.run.later( this, 'didSaveSnapshot', 1000);
  },

  didSaveSnapshot: function(){
    $('.saving-mask').remove();

    if ( this.get('pendingAction') ) {
      var action = this.get('pendingAction');
      this.set('pendingAction', null);
      this.send( action, this.get('lastSnap') );
    }

    this.get('controllers.autoSave').updateLastSaved();
  },

  demandFormDefaultList: function(params) {
    var controller = this.get('controllers.toolbar');
    this.set('controllers.template.isSaving', false);

    params.payload.newListName = [ Em.I18n.t('g.invalid_list_name') ];

    Pegasus.lookupController('modal').set('presenter', Pegasus.DefaultListModal.create({
      controller: controller,
      params: params,
      errors: params.payload
    }));
  },

  editFooter: function(){
    this.say(window.vrChildWindow, {
      method: 'editFooter',
      payload: {}
    });
  },

  demandFooterFields: function(params) {
    this.editFooter();

    var toolbarController = Pegasus.lookupController('toolbar');
    var templateController = Pegasus.lookupController('template');

    Pegasus.Helpers.addOneTimeObserver(toolbarController, 'content.payload.type', 'Footer', function(){
      toolbarController.set('errors', params.payload);
      templateController.set('isSaving', false);

      Pegasus.lookupController('modal').set('presenter', Pegasus.FooterFieldsModal.create({
        controller: toolbarController
      }));
    });

  },

  deleteSavedImage: function(id){
    this.say(window.parent, {
      method: 'deleteUserImage',
      payload: {
        imageID: id
      }
    });
  },

  didDeleteUserImage: Em.K,
  receiveSnapshot: function(){
    this.didSaveSnapshot();
  },

  requestUpgradeModal: function(){
    if( this.get('controllers.autoSave').saveSnapshot() ) {
      this.set('pendingAction', 'requestUpgradeModal' );
      return;
    }

    this.say(window.parent, {
      method: 'requestUpgrade',
      payload: {}
    });
  },

  requestUpgrade: Em.K,

  upgradeCancelled: function(){
    $('.logo-hider .switch-candy').click();
  },

  showEditorHelpVideo: function(){
    this.say(window.parent, {
      method: 'getEditorHelpVideo',
      payload: {}
    });
  },

  createContactList: function(listData){
    this.say(window.parent, {
      method: 'createContactList',
      payload: listData
    });
  },

  contactListCreated: function(params){
    var toolbarController = this.get('controllers.toolbar');

    toolbarController.setProperties({
      dataFormListId: params.payload.id,
      selectedList: params.payload
    });

    toolbarController.get('selectableContactLists').pushObject( params.payload );
  },

  prepareSendTestEmail: function(){
    this.say(window.parent, {
      method: 'prepareSendTestEmail',
      payload: {}
    });
  },

  prepareGoToTestKit: function(){
    this.say(window.parent, {
      method: 'prepareGoToTestKit',
      payload: {}
    });
  },

  provideFeedback: function(){
    this.say(window.parent, {
      method: 'offerFeedback',
      payload: {}
    });
  },

  notificationError: function(yml){
    this.say(window.parent, {
      method: 'notificationError',
      payload: {
        yml: yml
      }
    });
  },

  requestPexelsImagesFor: function(url, caller) {
    this.say(window.parent, {
      method: 'requestPexelsImages',
      payload: {
        url: url
      }
    });
  },

  requestIconImagesFor: function(url, caller) {
    this.say(window.parent, {
      method: 'requestIconImages',
      payload: {
        url: url
      }
    });
  },

  requestSavedImagesFor: function(url, caller) {
    this.say(window.parent, {
      method: 'requestSavedImages',
      payload: {
        url: url
      }
    });
  }
});

Pegasus.ImageEditorMixin = Em.Mixin.create({
  receiveEditedImage: function(params) {
    var imageID = 'fake-element',
      newURL = params.payload.data;

    Em.run(Pegasus.stateMachine, 'send', 'saveCustomImage', imageID, newURL);
    Ember.run.next(window.imageEditor, "close");
    Em.run( Pegasus, 'set', 'status', 'saving');
    Em.run.next(function(){
      $('#'+imageID).remove();
      $('body').removeClass('resizing');
    });
  },

  closedEditedImage: function(params) {
    Ember.run.next(window.imageEditor, "close");
  },

  launchImageEditor: function(url){
    Em.run.scheduleOnce('afterRender', this, function(){
      this.say( this.get('editorFrame'), {
        method: 'launchEditor',
        payload: {
          url: url
        }
      });
    });
  }
});
Pegasus.PhotoEditorSDKMixin = Pegasus.ImageEditorMixin;

Pegasus.FrameCommManagerController = Em.Controller.extend(Pegasus.IOEventsMixin, Pegasus.HistoryNavigator, Pegasus.FrameReceivedEventsMixin, Pegasus.PexelsMockMixin, Pegasus.IconsMockMixin, Pegasus.ImageEditorMixin, {
  needs: ['toolbar', 'autoSave', 'template', 'savedImages', 'iconsImages', 'pexelsImages'],
  init: function(){
    this._super();
    this.say(window.parent, {
      method: 'registerEmberFrame',
      payload: {
        id: 'pegasus' // this must match parent-side
      }
    });
  },
  listen: function(message){
    var data = message.data;
    var requestedMethod = data.method;

    if ( !requestedMethod ) { return; }

    // must have a payload
    // note this filters standard message events
    var payload = data.payload;

    this.send(requestedMethod, {
      payload: payload,
      requestSource: message.source
    });
  },
  say: function(target, message){
    target.postMessage( message, '*' );
  }
});
